import DataPaging from "./DataPaging.vue";

export default DataPaging;